import { Component } from '@angular/core';

import { NavController } from 'ionic-angular';

@Component({
  selector: 'settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {

  constructor(public navCtrl: NavController) {

  }

}


// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts